"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnServTt = void 0;
const base_1 = require("./base");
/**
 * TikTok
 */
class AnServTt extends base_1.AnServBase {
    static isLoaded() {
        return ((window.ttq !== undefined) &&
            (window.ttq.load !== undefined));
    }
    static sendPage(pixelId, tags = null) {
        ttq.page();
        this.logEvent({
            cmd: "page",
        });
        return true;
    }
    static sendEventAddToCart(pixelId) {
        ttq.track("AddToCart");
        this.logEvent({
            cmd: "track",
            event: "AddToCart",
        });
        return true;
    }
    static sendEventRegistration(pixelId) {
        ttq.track("Registration");
        this.logEvent({
            cmd: "track",
            event: "Registration",
        });
        return true;
    }
    static sendEventStartCheckout(pixelId) {
        ttq.track("StartCheckout");
        this.logEvent({
            cmd: "track",
            event: "StartCheckout",
        });
        return true;
    }
    static sendEventPurchase(pixelId) {
        ttq.track("Purchase");
        this.logEvent({
            cmd: "track",
            event: "Purchase",
        });
        return true;
    }
}
exports.AnServTt = AnServTt;
AnServTt.serviceName = "TikTok";
